import React, { useMemo, useRef, useState } from 'react';
import Border, { BorderType } from '../menu/border';
import { ITEM_SET_STATS, ItemRarity, ItemSetName, ItemStats } from './item-types';
import './item-set.css';
import ItemTooltip from './item-tooltip';

export interface ItemProps {
    itemSetName: ItemSetName;
    enableTooltip?: boolean;
}

const ItemSet: React.FC<ItemProps> = ({ itemSetName, enableTooltip = true }) => {

    const itemSetStats: ItemStats = useMemo(() => { return ITEM_SET_STATS[itemSetName] }, [itemSetName]);
    const [showTooltip, setShowTooltip] = useState(false);
    const timerRef = useRef<NodeJS.Timeout | null>(null);

    const handleMouseEnter = () => {
        timerRef.current = setTimeout(() => setShowTooltip(true), 150);
    };

    const handleMouseLeave = () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        setShowTooltip(false);
    };
    return (
        <div className='item-set'
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}>
            <Border type={itemSetStats.isWeapon ? BorderType.Weapon : BorderType.Default} rarity={ItemRarity.Set}>
                <img className='item-set-image'
                    src={`/resources/item_sets/${itemSetName}.png`}
                    alt={itemSetStats.name}
                     onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = '/resources/missing_art.png';
                    }}
                />
            </Border >
            {enableTooltip && showTooltip && <ItemTooltip itemStats={itemSetStats} />}
        </div>
    );
};

export default ItemSet;